module.exports = __webpack_public_path__ + "static/media/relation3.191ca6cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/relation3.jpg
// module id = 459
// module chunks = 0